import { createContext } from "react";

const AppContext = createContext({
  siteInfos: {},
  hasDiscount: false,
  setHasDiscount: () => {},
  productsCategory: [],
});

export default AppContext;